<template >
    <div>
        <QrCode/>
    </div>
</template>
<script>
import QrCode from '@/components/QrCode.vue';
// @ is an alias to /src


export default {
  name: 'GenerateView',
  components: {
    QrCode
}
}
</script>
<style >
    
</style>